<template>
    <zh-dialog
        v-model="visible"
        width="430"
        v-bind="props"
        class="zh-dialog zh-message-box-dialog"
        @submit="onSubmit"
        @close="onClose"
    >
        <div v-if="tip" class="tips">
            {{ tip }}
        </div>
        <component :is="render" v-if="render" />
        <el-form v-else-if="placeholder" ref="formRef" :model="form" :rules="rules" label-position="top">
            <el-form-item prop="textarea">
                <el-input
                    v-model="form.textarea"
                    style="width: 100%"
                    :rows="4"
                    type="textarea"
                    :placeholder="placeholder"
                    :maxlength="100"
                    show-word-limit
                    v-bind="inputProps"
                />
            </el-form-item>
        </el-form>
    </zh-dialog>
</template>

<script setup lang="ts">
import { ref } from "vue";
import type { FormInstance } from "element-plus";
import type { IOptions } from "@/components/zhMessageBox/type";
import { isFunction } from "../../../../utils";

const props = defineProps<IOptions>();
const emits = defineEmits(["action", "vanish"]);

const visible = defineModel<boolean>("visible", { default: true });
const formRef = ref<FormInstance>();
const form = ref({
    textarea: ""
});

const validateTextArea = (rule: any, value: any, callback: any) => {
    if (!value) callback(props.placeholder);
    callback();
};

const rules = ref({
    textarea: [{ validator: validateTextArea, trigger: ["blur", "change"] }]
});

const onSubmit = async () => {
    if (props.placeholder) {
        formRef.value?.validate(async valid => {
            if (!valid) return;
            try {
                if (props.callBack) {
                    const res = await props.callBack(form.value.textarea);
                    console.log(res);
                }
                emits("action", "submit");
                visible.value = false;
            } catch (err) {
                console.log(err);
            }
        });
    } else {
        // 没有placeholder，就没必要传callback,直接在 .then中去执行确定的函数
        // if (props.callBack) await props.callBack(form.value.textarea);
        if (props.beforeSubmit && isFunction(props.beforeSubmit)) {
            let res = await props.beforeSubmit().catch(console.log);
            if (res) {
                emits("action", "submit");
                visible.value = false;
            }
        } else {
            emits("action", "submit");
            visible.value = false;
        }
    }
};

const onClose = () => {
    emits("action", "cancel");
    visible.value = false;
};
</script>

<style scoped lang="scss">
.tips {
    color: #000000;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    margin-bottom: 12px;
}

// 确认弹窗头部按设计要求与关闭按钮保持 20px 间距及垂直居中。
:deep(.zh-message-box-dialog.el-dialog) {
    .el-dialog__header {
        padding: 20px 20px 16px;
        line-height: 16px;
    }

    .el-dialog__headerbtn {
        top: 20px;
        right: 20px;
        width: 20px;
        height: 20px;
    }

    .el-dialog__close {
        font-size: 20px;
    }
}
</style>
